<script>
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";

const greaterThanZero = (value) => value.replace(/,/g, "") > 0;
export default {
    components: {
        MaskedInput,
    },
    data() {
        return {
            submitted: false,
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "sort",
            sortDesc: false,
            fields: [
                {
                    key: "sort",
                    sortable: true,
                    order: 1,
                    label: "#"
                },
                {
                    key: "name",
                },
                {
                    key: "shortName",
                },
                {
                    key: "actions",
                    thStyle: { width: "100px" },
                },
            ],
            form: {
                id: 0,
                name: "",
                shortName: "",
            },
            cOrder: {
                id: 0,
                order: "0",
                sort: 0,
            },
            indexSelected: -1,
            tableBusy: false,
            currencyMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: false,
            }),
        };
    },
    validations: {
        form: {
            name: { required },
            shortName: { required },
        },
        cOrder: {
            order: { required, greaterThanZero },
        }
    },
    computed: {
        rows() {
            return this.tableData.length;
        },
    },
    created() {
        this.tableBusy = true;
        this.$store
            .dispatch("indicatoritemtag/GetAllItemTag")
            .then((res) => {
                if(res.data.error){
                    this.tableBusy = false;
                    return this.showToast(res.data.errorMessage,"error");
                }
                this.tableBusy = false;
                this.tableData = res.data.sort((a, b) => a.sort - b.sort);
            })
            .catch(() => {
                this.tableBusy = false;
                this.showToast("Something went wrong!","error");
            });
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        addFC() {
            this.onReset();
            this.modalTitle = "Create New KPI Tags";
            this.$bvModal.show("kpi-tag-modal");
        },
        onChangeOrder(){
            this.submitted = true;
            this.$v.cOrder.$touch();
            if (this.$v.cOrder.$invalid) {
                return;
            }
            let copyData = cloneDeep(this.tableData);
            let index = copyData.findIndex((x) => x.id == this.cOrder.id)
            let data = cloneDeep(copyData[index]);
            copyData.splice(index, 1);
            data.sort = this.cOrder.order;
            copyData.splice(this.cOrder.order - 1, 0, data);
            let sorting = [];
            copyData.forEach((x, i) => {
                x.sort = i + 1;
                sorting.push({ id: x.id, sort: x.sort });
            });
            this.$store
                .dispatch("indicatoritemtag/UpdateSorting", sorting)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage,"error");
                    }
                    this.tableData = copyData;
                    this.$bvModal.hide("kpi-change-order-modal");
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!","error");
                });
        },
        onCreate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            var data = cloneDeep(this.form);
            if (this.form.id > 0) {
                this.$store
                    .dispatch("indicatoritemtag/UpdateItemTag", data)
                    .then((res) => {
                        this.tableData.splice(this.indexSelected, 1, data);
                        this.$bvModal.hide("kpi-tag-modal");
                        this.showToast("Successfully updated","success");
                    })
                    .catch((err) => {
                        console.log(err)
                        this.showToast("Something went wrong!","error");
                    });
            } else {
                this.$store
                    .dispatch("indicatoritemtag/CreateItemTag", data)
                    .then((res) => {
                        this.tableData.push(res.data);
                        this.$bvModal.hide("kpi-tag-modal");
                        this.showToast("Successfully created","success");
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!","error");
                    });
            }
            this.submitted = false;
        },
        onReset() {
            this.form = {
                id: 0,
                name: "",
                shortName: "",
            };
        },
        updateItem(props) {
            this.form = cloneDeep(props.item);
            this.indexSelected = this.tableData.indexOf(props.item);
            this.modalTitle = "Update KPI Tags";
            this.$bvModal.show("kpi-tag-modal");
        },
        hideModal() {
            this.$bvModal.hide("kpi-tag-modal");
        },
        deleteItem(props) {
            var index = this.tableData.indexOf(props.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("indicatoritemtag/DeleteItemTag", props.item.id)
                        .then((res) => {
                            if (res.status == 204) {
                                this.tableData.splice(index, 1);
                                this.showToast("Successfully deleted","success");
                            }
                        })
                        .catch(() => {
                            this.showToast("Cannot be deleted!","error");
                        });
                }
            });
        },
        showSortModal(item){
            this.$v.cOrder.$reset();
            this.cOrder.id = item.id;
            this.cOrder.sort = item.sort.toString()
            this.$bvModal.show('kpi-change-order-modal')
        }
    },
};
</script>

<template>
    <div>
        <b-modal
            id="kpi-change-order-modal"
            title="Change Order"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onChangeOrder"
                class="needs-validation"
                ref="apiForm"
            >
                <div class="mb-3 d-flex w-100 gap-2">
                    <div  class="w-50">
                        <label for="orderFrom">From </label>
                        <input
                            autocomplete="off"
                            id="orderFrom"
                            type="text"
                            v-model="cOrder.sort"
                            placeholder="Enter Sort..."
                            class="form-control"
                            disabled
                        />
                    </div>
                    <div class="w-50">
                        <label for="orderTo">To </label>
                        <masked-input
                            autocomplete="off"
                            id="orderTo"
                            type="text"
                            v-model="cOrder.order"
                            placeholder="Enter Order..."
                            class="form-control"
                            :mask="currencyMask"
                            :class="{
                                'is-invalid':
                                    submitted &&
                                    $v.cOrder.order.$error,
                            }"
                        ></masked-input>
                        <div
                            v-if="submitted && $v.cOrder.order.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.cOrder.order.required">This value is required.</span>
                            <span v-if="!$v.cOrder.order.greaterThanZero">This value must be greater than zero.</span
                            >
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                        type="submit"
                        class="btn btn-primary"
                    >
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('kpi-change-order-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <div class="row">
            <div class="col-12">
                <div class="card border">
                    <div class="card-body">
                        <div
                            class="
                                d-flex
                                justify-content-between
                                align-items-center
                            "
                        >
                            <h4 class="card-title m-0">KPI Tag List</h4>
                            <button
                                type="button"
                                @click="addFC()"
                                class="
                                    btn btn-md btn-info
                                    d-flex
                                    align-items-center
                                "
                            >
                                <i class="bx bx-plus fs-6"></i>Create New
                            </button>
                            <b-modal
                                id="kpi-tag-modal"
                                :title="modalTitle"
                                size="md"
                                title-class="font-18"
                                hide-footer
                                no-close-on-backdrop
                            >
                                <form
                                    @submit.prevent="onCreate"
                                    class="needs-validation"
                                    ref="apiForm"
                                >
                                    <div class="mb-3">
                                        <label for="name">Tag Name </label>
                                        <input
                                            autocomplete="off"
                                            id="name"
                                            type="text"
                                            v-model="form.name"
                                            placeholder="Enter Name..."
                                            class="form-control"
                                            :class="{
                                                'is-invalid':
                                                    submitted &&
                                                    $v.form.name.$error,
                                            }"
                                        />
                                        <div
                                            v-if="
                                                submitted &&
                                                $v.form.name.$error
                                            "
                                            class="invalid-feedback"
                                        >
                                            <span
                                                v-if="
                                                    !$v.form.name
                                                        .required
                                                "
                                                >This value is
                                                required.</span
                                            >
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <label for="description"
                                            >Tag Shortname
                                        </label>
                                        <input
                                            autocomplete="off"
                                            id="name"
                                            type="text"
                                            v-model="form.shortName"
                                            placeholder="Enter Name..."
                                            class="form-control"
                                            :class="{
                                                'is-invalid':
                                                    submitted &&
                                                    $v.form.shortName.$error,
                                            }"
                                        />
                                        <div
                                            v-if="
                                                submitted &&
                                                $v.form.shortName
                                                    .$error
                                            "
                                            class="invalid-feedback"
                                        >
                                            <span
                                                v-if="
                                                    !$v.form.shortName
                                                        .required
                                                "
                                                >This value is
                                                required.</span
                                            >
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button
                                            type="submit"
                                            class="btn btn-primary"
                                        >
                                            Save changes
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-link"
                                            @click="hideModal"
                                        >
                                            Close
                                        </button>
                                    </div>
                                </form>
                            </b-modal>
                        </div>
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_length"
                                    class="dataTables_length"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                    >
                                        Show&nbsp;
                                        <b-form-select
                                            class="
                                                form-select form-select-sm
                                                mx-1
                                            "
                                            v-model="perPage"
                                            size="sm"
                                            :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter text-md-end"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                    >
                                        Search:
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filter"
                                            type="search"
                                            placeholder="Search..."
                                            class="
                                                form-control form-control-sm
                                                ms-2
                                            "
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                class="datatables"
                                :items="tableData"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                                :busy="tableBusy"
                                @filtered="onFiltered"
                                bordered
                                outlined
                                hover
                                striped
                                show-empty
                            >
                                <template #empty="scope">
                                    <div class="text-center">
                                        {{ scope.emptyText }}
                                    </div>
                                </template>
                                <template #table-busy>
                                    <div
                                        class="
                                            d-flex
                                            justify-content-center
                                            align-items-center
                                        "
                                    >
                                        <div class="preloader-component me-2">
                                            <div class="status">
                                                <div
                                                    class="
                                                        spinner-chase
                                                        w-20px
                                                        h-20px
                                                    "
                                                >
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>
                                <template #cell(sort)="data">
                                    <a href="javascript: void(0);" class="hover-underline text-dark" @click="showSortModal(data.item)">
                                        {{ data.value }}
                                    </a>
                                </template>
                                <template #cell(actions)="row">
                                    <div class="float-end">
                                        <b-dropdown
                                            id="dropdown-dropleft"
                                            right
                                            variant="link"
                                            toggle-class="text-decoration-none"
                                            menu-class="dropdown-menu-end"
                                            no-caret
                                        >
                                            <template #button-content>
                                                <i
                                                    class="fas fa-ellipsis-v"
                                                ></i>
                                            </template>
                                            <b-dropdown-item
                                                @click="updateItem(row)"
                                                variant="dark"
                                                ><i
                                                    class="
                                                        bx bx-edit
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Update</b-dropdown-item
                                            >
                                            <b-dropdown-item
                                                @click="deleteItem(row)"
                                                variant="danger"
                                                ><i
                                                    class="
                                                        mdi mdi-trash-can
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Delete</b-dropdown-item
                                            >
                                        </b-dropdown>
                                    </div>
                                </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div
                                    class="
                                        dataTables_paginate
                                        paging_simple_numbers
                                        float-end
                                    "
                                >
                                    <ul
                                        class="
                                            pagination pagination-rounded
                                            mb-0
                                        "
                                    >
                                        <!-- pagination -->
                                        <b-pagination
                                            v-model="currentPage"
                                            :total-rows="rows"
                                            :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
